module.exports = __webpack_public_path__ + "img/shoulder-mesomorph-female.12f29490.svg";